export default "__VITE_ASSET__BgX0KjDR__"